import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type ExitIntentCtaProps = CtaShellProps

export function ExitIntentCta(props: ExitIntentCtaProps) {
  return <CtaShell {...props} placement="exit-intent" layout={props.layout ?? "card"} />
}
